<template
  ><div>
    <Spinner v-if="!me" :size="16" color="blue" />
    <div v-if="me" class="w-full">
      <!-- MAIN CONENT -->
      <div class="col-span-1 2xl:col-span-2 flex gap-6">
        <!--  Payment Info-->
        <!-------------------->
        <!-------------------->
        <!-------------------->
        <div class="flex flex-col gap-5">
          <h2 class="font-bold mr-2 pb-4 border-b">Payment Information</h2>
          <Spinner v-if="!wiseAccountDetails" :size="16" color="blue" />
          <div
            v-if="
              wiseAccountDetails?.recipientAccount ||
                me.billingContact.paymentMethod == 'Bitcoin'
            "
            class="grid grid-cols-1 md:grid-cols-2 gap-4"
          >
            <YInput
              v-if="me && me.billingContact.paymentMethod == 'Bitcoin'"
              label="Crytocurrency"
              :readonly="true"
              :value="this.walletType"
            />
            <YInput
              v-if="me && me.billingContact.paymentMethod == 'Bitcoin'"
              label="Wallet Address"
              :readonly="true"
              :value="this.walletId"
            />
            <YInput
              v-if="me && me.billingContact.paymentMethod == 'Wise'"
              label="Currency"
              :readonly="true"
              v-model="currency.code"
            />
            <YInput
              v-if="
                me && currency.code && me.billingContact.paymentMethod == 'Wise'
              "
              label="Pay Option"
              :readonly="true"
              v-model="formattedTitle"
            />
            <YInput
              v-if="
                me &&
                  payOption?.title &&
                  me.billingContact.paymentMethod == 'Wise'
              "
              label="Account Holder"
              :readonly="true"
              v-model="this.filters.name.fullName"
            />

            <div
              v-for="(value, key, index) in this.filters.aDetails"
              :key="index"
            >
              <YInput
                v-if="
                  me &&
                    payOption?.title &&
                    me.billingContact.paymentMethod == 'Wise'
                "
                :label="formatWiseLabels(key)"
                :readonly="true"
                v-model="filters.aDetails[key]"
              />
            </div>
          </div>

          <!--Auth && update payment info-->
          <!-------------------->
          <!-------------------->
          <!-------------------->
          <!--Show the QR code image only if we haven't validated/authenticated with it before-->
          <div
            v-if="
              this.qrCodeUrl &&
                me?.is2faEnabled == false &&
                this.validQR == false
            "
            class="flex flex-col gap-4"
          >
            <div>
              <img :src="qrCodeUrl" alt="QR Code for 2FA" />
            </div>
            <p class="text-xs">
              To edit payment details, please scan the QR code with your
              preferred authenticator app (Google Authenticator recommended) to
              set up 2FA.
            </p>
            <p class="text-xs -mt-2">
              ⚠️ <span class="font-bold">Important:</span> Make sure you are
              100% certain which device and account you use for authentication.
              Once 2FA is configured, it cannot be modified or transferred. If
              this account is accessed by multiple users, ensure that all users
              have access to the same authenticator, or you may be permanently
              locked out.
            </p>
            <YInput label="Enter 6-digit code" v-model="code" class="w-64" />
            <YButton color="blue" class="w-40" @click="verifyCode()">
              Verify
            </YButton>
          </div>
          <!-- only show if we have setup an authenticator -->
          <div
            v-if="
              this.validQR == false &&
                me?.is2faEnabled == true &&
                me?.is2faValid != true
            "
            class="grid grid-cols-1 gap-4"
          >
            <h2>
              To edit payment details please authenticate using 2fa
              authenticator code:
            </h2>
            <YInput label="Enter 6-digit code" v-model="code" />
            <YButton color="blue" @click="verifyCode()" class="w-40">
              Verify
            </YButton>
          </div>

          <!-- authenticated show the update/create wise account box-->
          <!-------------------->
          <!-------------------->
          <div
            v-if="
              (wiseAccountDetails && validQR == true) || me?.is2faValid == true
            "
          >
            <YButton color="blue" @click="openCreatePaymentInfoModal()">
              {{ me.billingContact.paymentMethod ? 'Change ' : 'Add' }} Payment
              Details
            </YButton>
          </div>

          <!--Payment History-->
          <!-------------------->
          <!-------------------->
          <Spinner v-if="!userPaymentHistory" :size="16" color="blue" />
          <h2 class="font-bold mr-2 pb-4 border-b">Payment History</h2>
          <YTable
            class="table-striped table-hover overflow-hidden"
            :scroll-x="false"
            :data="userPaymentHistory.data || []"
            :isLoading="!userPaymentHistory"
          >
            <template slot="header-row">
              <th style="min-width:9rem; max-width: 9rem;">Date</th>
              <th style="width: 5rem">Amount (USD)</th>
              <th>Payment Type</th>
              <th>Status</th>
              <th>Reciept</th>
            </template>

            <template slot="row" slot-scope="props">
              <td>
                {{ formatDate(props.rowData.created) }}
              </td>
              <td>
                {{
                  Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                  }).format(props.rowData.targetValue)
                }}
              </td>
              <td v-if="props.rowData.paymentType == 'bitcoin'">
                Crypto Wallet (BTC)
              </td>
              <td v-else>
                Bank Transfer (via Wise)
              </td>
              <td>
                {{
                  props.rowData.status
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, char => char.toUpperCase())
                }}
              </td>
              <td>
                <YButton
                  v-if="props.rowData.paymentType == 'bitcoin'"
                  color="gray"
                  class="w-full"
                  :is-loading="receiptLoading"
                  @click="openUrl(props.rowData.transactionUrl)"
                >
                  Open Transaction Url
                </YButton>
                <YButton
                  v-else
                  color="gray"
                  class="w-full"
                  :is-loading="receiptLoading"
                  @click="downloadTransferReceipt(props.rowData.transferId)"
                >
                  Download Receipt
                </YButton>
              </td>
            </template>

            <template v-slot:after>
              <YPagination
                v-if="userPaymentHistory.paginatorInfo"
                :data="userPaymentHistory.paginatorInfo"
                @load-page="loadPage"
                @next-page="nextPage"
                @previous-page="previousPage"
                :key="totalPages"
                @per-page="perPageSelection"
              ></YPagination>
            </template>
          </YTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import gql from 'graphql-tag'
// import ME_QUERY from '@/graphql/User/MeQuery.gql'

import ME_QUERY from '@/graphql/User/MeQuery.gql'
import WISE_ACCOUNT_DETAILS from '@/graphql/PaymentOption/WiseGetAccountDetails.gql'
import USER_PAYMENT_HISTORY from '@/graphql/PaymentOption/UserPaymentHistory.gql'
import WISE_GET_TRANSFER_RECEIPT from '@/graphql/PaymentOption/WiseGetTransferReceipt.gql'
import GENERATE_2FA_SETUP from '@/graphql/Auth/Generate2FASetup.gql'
import VERIFY_2FA_CODE from '@/graphql/Auth/Verify2FACode.gql'
import YPagination from '@/components/ui/YPagination.vue'
import CreatePaymentInfo from '@/views/Publisher/Finance/CreatePaymentInfo.vue'

export default {
  components: {
    YPagination
  },
  props: {},
  apollo: {
    userPaymentHistory: {
      query: USER_PAYMENT_HISTORY,
      update: data => data.userPaymentHistory,
      variables() {
        return {
          page: this.currentPage,
          first: this.perPage,
          filters: {
            userId: { value: [this.me?.id] }
          },
          orderBy: [{ column: 'created', order: 'DESC' }]
        }
      },
      result({ data }) {
        console.log(this.currentPage)
        this.totalPages = data.userPaymentHistory.paginatorInfo.lastPage
      },
      fetchPolicy: 'network-only',
      deep: true
    },
    me: {
      query: ME_QUERY,
      result(data) {
        this.paymentSummary = data.data.me.billingContact ?? null
        if (this.paymentSummary) {
          this.paymentSummary.nextDate = this.paymentSummary.paymentMessage

          if (this.paymentSummary.confirmedAsDate != null) {
            this.paymentSummary.confirmedAsDate = this.paymentSummary.confirmedAsDate.split(
              ' '
            )[0]
          }
          if (
            this.paymentSummary.paymentMessage == null &&
            this.paymentSummary.nextPaymentDate != null
          ) {
            this.paymentSummary.nextDate = this.paymentSummary.nextPaymentDate.split(
              ' '
            )[0]
          }
          if (this.paymentSummary.paymentBalance) {
            if (
              this.paymentSummary?.paymentBalance.split('.')[1]?.length == 1
            ) {
              this.paymentSummary.paymentBalance =
                this.paymentSummary.paymentBalance + '0'
            }
          }
        }
        this.localUser = data.data.me
        //this.paymentThreshold(this.paymentSummary)
        this.canadianResident = data.data.me.primaryContact.country.code == 'CA'
        this.walletType = data.data.me.userDetails?.cryptoWallet?.walletType
        this.walletId = data.data.me.userDetails?.cryptoWallet?.walletId
      }
    },
    wiseAccountDetails: {
      query: WISE_ACCOUNT_DETAILS,
      update: data => data.wiseGetAccountDetails,
      variables() {
        return {
          input: {
            //accountId: this.user.userDetails?.wiseAccountId ?? 838372526,
            //wiseAccountId: 984773181,
            userId: undefined
          }
        }
      },
      result(results) {
        this.createFilters(
          JSON.parse(JSON.stringify(results.data.wiseGetAccountDetails))
        )
        this.payOptions = this.getPayOptions()
        console.log()
      },
      fetchPolicy: 'network-only',
      deep: true
    }
  },
  data() {
    return {
      walletId: null,
      walletType: null,
      qrCodeUrl: null,
      validQR: false,
      code: null,
      receiptLoading: false,
      wiseTransferId: null,
      wiseTransferResult: null,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      name: '',
      payOption: null,
      currency: '',
      email: '',
      address: '',
      paymentBalance: '',
      nextPaymentDate: '',
      paymentMessage: '',
      balanceUploadDate: '',
      paymentMethod: '',
      threshold: '',
      resetDetails: false,
      filters: {
        name: {},
        aDetails: {}
      }
    }
  },
  mounted() {
    this.$events.listen('refreshPaymentOptions', () => {
      this.$apollo.queries.wiseAccountDetails.refetch()
    })
    this.$events.listen('refreshMeQuery', async () => {
      await this.$apollo.queries.me.refetch()
      await this.$apollo.queries.wiseAccountDetails.refetch()
    })
    this.generate2FA()
  },
  methods: {
    formatWiseLabels(key) {
      return key
        .split('.')
        .map(
          part =>
            part
              .replace(/([A-Z])/g, ' $1') // Insert space before capital letters (camelCase handling)
              .replace(/^./, char => char.toUpperCase()) // Capitalize first letter
        )
        .join(' ')
    },
    openCreatePaymentInfoModal() {
      this.$modal.show(
        CreatePaymentInfo,
        { user: this.me },
        {
          height: 'auto',
          width: '80%',
          maxWidth: 600,
          adaptive: true,
          scrollable: true,
          classes: ['overflow-visible-important']
        }
      )
    },
    async verifyCode() {
      try {
        const response = await this.$apollo.mutate({
          mutation: VERIFY_2FA_CODE,
          variables: {
            code: this.code
          }
        })

        const result = response.data.verify2FACode

        if (result == true) {
          console.log('2FA verification successful')
          this.$toastr.s('2FA verification successful', 'Verified')
          this.validQR = true
        } else {
          console.log('2FA verification failed')
          this.$toastr.s('2FA verification successful', 'Verified')
          this.validQR = false
        }
      } catch (error) {
        console.error('Error verifying 2FA code:', error)
        this.validQR = false
      }
    },
    async generate2FA() {
      try {
        const response = await this.$apollo.mutate({
          mutation: GENERATE_2FA_SETUP
        })
        this.qrCodeUrl = response.data.generate2FASetup.qrCodeUrl
      } catch (error) {
        console.error('2FA generation failed:', error)
      }
    },
    openUrl(url) {
      window.open(url, '_blank')
    },
    loadPage(page) {
      this.currentPage = page
    },
    nextPage() {
      this.currentPage++
    },
    previousPage() {
      this.currentPage--
    },
    perPageSelection(value) {
      this.perPage = value
    },
    loadMore() {
      this.perPage = this.perPage + this.loadMoreIncrement
    },
    getPayOptions() {
      var types = []
      this.wiseAccountDetails?.accountRequirementsData.forEach(element => {
        types.push({
          title: element.title,
          key: element.key
        })
      })
      return types
    },

    formatDate(dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },

    async load() {
      try {
        const response = await this.$apollo.query({
          query: WISE_GET_TRANSFER_RECEIPT,
          variables: {
            filters: {
              transferId: this.wiseTransferId
            }
          },
          fetchPolicy: 'network-only' // ← ensures no cache is used
        })

        this.wiseTransferResult = response.data
        return this.wiseTransferResult
      } catch (error) {
        console.error('GraphQL query error:', error)
        return null
      }
    },

    async refetchReceipt() {
      return await this.load()
    },

    base64ToUint8Array(base64) {
      const binaryString = window.atob(base64)
      const len = binaryString.length
      const bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes
    },

    triggerFileDownload(blob, filename) {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
    },

    async downloadTransferReceipt(transferId) {
      console.log(transferId)
      this.receiptLoading = true
      try {
        this.wiseTransferId = transferId

        let queryResult = await this.load()

        if (!queryResult) {
          queryResult = await this.refetchReceipt()
        }

        await new Promise(resolve => setTimeout(resolve, 2000))

        const pdfRaw = this.wiseTransferResult?.wiseGetTransferReceipt?.pdfData

        if (!pdfRaw) {
          this.receiptLoading = false
          console.error('No PDF data found for transfer receipt.')
          return
        }

        const bytes = this.base64ToUint8Array(pdfRaw)
        const blob = new Blob([bytes], { type: 'application/pdf' })
        this.triggerFileDownload(blob, `wise_receipt_${transferId}.pdf`)
        this.receiptLoading = false
      } catch (error) {
        this.wiseTransferId = transferId
        console.error('Error fetching transfer receipt:', error)
        this.receiptLoading = false
      }
    },

    createFilters(data) {
      const excludedKeys = [
        'balanceAccountProfileId',
        'hashedByLooseHashAlgorithm'
      ]

      for (const key in data.recipientAccount) {
        let value = data.recipientAccount[key]
        if (key === 'displayFields') {
          for (const vKey in value) {
            if (value[vKey]['key'] === 'email') {
              this.email = value[vKey]['value']
            }
          }
          continue
        }

        if (key === '__typename' || key === 'displayFields') continue

        if (key === 'type') {
          this.payOption = value
          continue
        }

        if (key === 'currency' && this.resetDetails) continue
        if (key === 'currency' && !this.resetDetails) {
          this.currency = value
          continue
        }

        if (typeof value === 'object' && value !== null) {
          const innerObject = {}
          for (const vKey in value) {
            if (vKey === '__typename' || excludedKeys.includes(vKey)) continue
            if (key === 'address') {
              innerObject[`address.${vKey}`] = value[vKey]
            } else {
              innerObject[vKey] = value[vKey]
            }
          }

          // accountType and legalType to hold only the 'name' value
          if (key === 'details') {
            if (innerObject.accountType && innerObject.accountType.name) {
              innerObject.accountType = innerObject.accountType.name
            }
            if (innerObject.legalType && innerObject.legalType.name) {
              innerObject.legalType = innerObject.legalType.name
            }

            this.filters.aDetails = innerObject
          } else {
            this.filters[key] = innerObject
          }
        } else {
          this.filters[key] = value
        }
      }
      // Merge address and aDetails if address exists in filters
      if (this.filters?.address !== undefined) {
        const merged = { ...this.filters.address, ...this.filters.aDetails }
        this.filters.aDetails = merged
      }

      if (this.resetDetails) {
        this.payOption = null
        this.filters.aDetails = {}
        this.resetDetails = false
      }
    }
  },
  computed: {
    formattedTitle() {
      if (!this.payOption) return ''

      const titleMap = {
        ach: 'ACH',
        fedWireLocal: 'Wire',
        iban: 'IBAN',
        aba: 'ACH'
      }

      return (
        titleMap[this.payOption.title] ||
        this.payOption.title
          .replace(/([a-z])([A-Z])/g, '$1 $2')
          .replace(/(^|\s)([a-z])/g, (match, p1, p2) => p1 + p2.toUpperCase())
      )
    },
    frequency() {
      return this.paymentSummary
        ? this.paymentSummary.paymentFrequency.split(/(?=[A-Z])/).join(' ')
        : null
    },
    paymentTerms() {
      return this.paymentSummary
        ? this.paymentSummary.paymentTerms
            .replace('NET', 'Net')
            .split(/(\d+\.|\d+)+/g)
            .join(' ')
        : null
    },
    paymentMethodsTableValues() {
      return this.paymentThresholds.filter(payment => payment.threshold !== '-')
    }
  }
}
</script>
